export * from './device.page';
